import { currentBuilderState } from '../builder.state';

export function checkCacheCriteriaParams(): void {
    const state = currentBuilderState();
    const vp = state.viewParams;

    if (
        state.selectableRoleIds != null &&
        !state.selectableRoleIds.includes(vp.role?.[0]?.id)
    ) {
        vp.role = null;
    }

    if (
        state.selectableSiteIds != null &&
        !state.selectableSiteIds.includes(vp.site?.[0]?.id)
    ) {
        vp.site = null;
    }

    if (
        state.selectableQueueIds != null &&
        !state.selectableQueueIds.includes(vp.queue?.[0]?.id)
    ) {
        vp.queue = null;
    }

    if (
        state.selectableSuperGroupIds != null &&
        !state.selectableSuperGroupIds.includes(vp.superGroup?.[0]?.id)
    ) {
        vp.superGroup = null;
    }
}
